import { render, staticRenderFns } from "./Abuses.vue?vue&type=template&id=a35455f6&"
import script from "./Abuses.vue?vue&type=script&lang=js&"
export * from "./Abuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports